import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'

export enum ViewMode {
  LIST = 'list',
  CARD = 'card',
}

interface ViewModeToggleProps {
  view: ViewMode
  onViewChange: (view: ViewMode) => void
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ view, onViewChange }) => {
  const classes = useStyles()
  const url = new URL(window.location.href)

  const handleViewChange = (newView: ViewMode) => {
    // Update URL query parameter
    url.searchParams.set('view', newView)
    window.history.replaceState({}, '', url.toString())

    // Update the view state
    onViewChange(newView)
  }

  return (
    <div className={classes.viewActionsButtons}>
      <div
        className={clsx(classes.icon, classes.listIcon, {
          [classes.listIconActive]: view === ViewMode.LIST,
        })}
        onClick={() => handleViewChange(ViewMode.LIST)}
        role="button"
        tabIndex={0}
        aria-label="Switch to list view"
        data-testid="view-mode-toggle--list"
      >
        <img src="/ui/images/list-icon.svg" alt="List view" data-testid="view-mode-toggle--img-0" />
      </div>
      <div
        className={clsx(classes.icon, classes.gridIcon, {
          [classes.gridIconActive]: view === ViewMode.CARD,
        })}
        onClick={() => handleViewChange(ViewMode.CARD)}
        role="button"
        tabIndex={0}
        aria-label="Switch to grid view"
        data-testid="view-mode-toggle--card"
      >
        <img src="/ui/images/grid-icon.svg" alt="Grid view" data-testid="view-mode-toggle--img-1" />
      </div>
    </div>
  )
}

interface StyleProps {
  view: ViewMode
}

const useStyles = makeStyles<Theme>((theme) => ({
  viewActionsButtons: {
    width: theme.spacing(10),
    display: 'flex',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
  },
  icon: {
    width: 40,
    height: 36,
    paddingTop: '2px',
    paddingBottom: '2px',
    gap: theme.spacing(1),
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  gridIcon: {
    opacity: 0.5,
  },
  gridIconActive: {
    opacity: 1,
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.common.white,
  },
  listIcon: {
    opacity: 0.5,
  },
  listIconActive: {
    opacity: 1,
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.common.white,
  },
}))

export default ViewModeToggle
